import { useAppSelector } from "../../hooks/app";
import { AuthStatus } from "../../interfaces/session";
import { selectAuthStatus, selectCompatibilityInfos, selectMode, selectScreen, selectUser } from "./selectors";

export const useAuthStatus = (): AuthStatus => useAppSelector(selectAuthStatus);
export const useScreen = () => useAppSelector(selectScreen);
export const useMode = () => useAppSelector(selectMode);
export const useUser = () => useAppSelector(selectUser);
export const useCompatibilityInfos = () => useAppSelector(selectCompatibilityInfos);